module.exports = __webpack_public_path__ + "img/filter.244e3d96.svg";